export type { TbclEntry } from "@leonsilicon/tbcl";
export { default } from "@leonsilicon/tbcl";
